import {
  $convertFromMarkdownString,
  MultilineElementTransformer,
  Transformer,
} from '@lexical/markdown';
import { LexicalNode } from 'lexical';
import {
  $createSuggestionNode,
  $isSuggestionNode,
  $sourceSuggestion,
} from '../../nodes/SuggestionNode';
import { Source } from '../../types';

const VALID_SOURCES: Source[] = ['default', 'note', 'inline'];

export function isValidSource(source: string | null): source is Source {
  return VALID_SOURCES.includes(source as Source);
}

export const createSuggestionTransformer = (
  transformers: Transformer[],
): MultilineElementTransformer => ({
  type: 'multiline-element',
  dependencies: [],

  regExpStart: /^<suggestion(?: source="([^"]*)")?>$/,
  regExpEnd: /^<\/suggestion>$/,

  export: (node: LexicalNode, traverseChildren) => {
    if (!$isSuggestionNode(node)) {
      return null;
    }

    const source = $sourceSuggestion(node);
    const output: string[] = [];

    if (source !== 'default') {
      output.push(`<suggestion source="${source}">`);
    } else {
      output.push('<suggestion>');
    }

    output.push(traverseChildren(node));
    output.push('</suggestion>');
    return output.join('\n');
  },

  replace: (parentNode, children, startMatch, endMatch, linesInBetween) => {
    if (!startMatch || !endMatch) {
      return;
    }

    const sourceAttr = startMatch[1];
    const source: Source = sourceAttr && isValidSource(sourceAttr) ? sourceAttr : 'default';

    const suggestion = $createSuggestionNode(source, true);
    if (children) {
      suggestion.append(...children);
    } else if (linesInBetween) {
      $convertFromMarkdownString(linesInBetween.join('\n'), transformers, suggestion);
    }

    parentNode.append(suggestion);

    suggestion.selectNext();
  },
});
